import { Grid, Box, Button } from "@mui/material";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import Appointment from "../interface/appointment";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import BootstrapTooltip from "../../../components/bootstrapTooltip/bootstrapTooltip";
import ExpandMoreButton from "../../../components/inputs/expandMoreButton/expandMoreButton";

const RenderAppointmentActions = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => {
  const {
    deleteAppointment,
    setDeleteAppointment,
    doDeleteAppointment,
    setFiltertedAppointments,
    isAdmin,
    setBookingAppointment,
  }: {
    deleteAppointment: Appointment | null;
    setDeleteAppointment: React.Dispatch<
      React.SetStateAction<Appointment | null>
    >;
    doDeleteAppointment: () => void;
    setFiltertedAppointments: React.Dispatch<
      React.SetStateAction<Appointment[] | null>
    >;
    isAdmin: boolean;
    setBookingAppointment: React.Dispatch<
      React.SetStateAction<Appointment | null>
    >;
  } = React.useContext(AppointmentOverviewContext);

  // free appointments are booked onto a participant, booked ones are moved to another one;
  // cancelled, missed and past appointments stay as they are, a booking confirmation for a
  // date that has passed would be wrong
  const canBeBooked: boolean =
    (appointment.status === "F" || appointment.status === "G") &&
    new Date(appointment.date).toISOString().split("T")[0] >=
      new Date().toISOString().split("T")[0];

  const handleExpandClick = (appointmentId: number): void => {
    setFiltertedAppointments(
      (prevAppointments) =>
        prevAppointments?.map((app) =>
          app.id === appointmentId ? { ...app, expand: !app.expand } : app
        ) || null
    );
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={2}
      sx={{ display: "flex", alignItems: "center", gap: 1 }}
    >
      {isAdmin && (
        <BootstrapTooltip
          placement="right"
          title={
            appointment.status === "G"
              ? "Auf andere:n Teilnehmer:in umbuchen"
              : "Auf Teilnehmer:in buchen"
          }
          children={
            <Box
              sx={{
                display: "flex",
                justifyContent: "right",
              }}
            >
              <Button
                disabled={!canBeBooked}
                onClick={() => setBookingAppointment(appointment)}
                variant="outlined"
                color="inherit"
              >
                <PersonAddAltOutlinedIcon />
              </Button>
            </Box>
          }
        />
      )}

      <BootstrapTooltip
        placement="right"
        title={"Termin löschen"}
        children={
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              width: "100%",
            }}
          >
            <Button
              disabled={appointment.status !== "F"}
              onClick={() =>
                deleteAppointment?.id !== appointment.id
                  ? setDeleteAppointment(appointment)
                  : doDeleteAppointment()
              }
              variant="outlined"
              color="inherit"
            >
              {deleteAppointment?.id !== appointment.id ? (
                <DeleteOutlineOutlinedIcon />
              ) : (
                "Sicher?"
              )}
            </Button>
          </Box>
        }
      />
      <ExpandMoreButton
        disabled={appointment.status === "F"}
        onClick={() => handleExpandClick(appointment.id)}
        expand={appointment.expand}
      />
    </Grid>
  );
};

export default RenderAppointmentActions;
